import axios from "axios";
import { api } from "./_client";

export async function listPricingStrategies() {
    const { data } = await api.get("/pricing-strategies");
    return data;
}

export async function updatePricingStrategies(strategies) {
    const { data } = await api.patch("/admin/pricing-strategies", { strategies });
    return data;
}

export async function testPricingPrompt(payload) {
    // Larger timeout — the test makes a real Claude call. Default axios
    // timeout is fine for most cases, but we bump it here so long
    // reasoning chains don't abort the UI.
    const { data } = await api.post(
        "/admin/pricing-strategies/test",
        payload,
        { timeout: 120000 },
    );
    return data;
}

// ----- Leads (dynamic columns + rows) -----
